import { CHANGE_PW } from "constants/paths"

export const CONFIGURATION_PATH = "phronesis.usermenu.configuration"
export const CHANGE_PW_PATH = "phronesis.usermenu.change_pw"

export const BREADCRUMB_OPTIONS = [
	{
		id: CONFIGURATION_PATH,
		path: "",
	},
	{
		id: CHANGE_PW_PATH,
		path: CHANGE_PW,
	},
]
